/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IncortaSubscriptionStatusEnum = 'PENDING' | 'DONE' | 'FAILED';

export const IncortaSubscriptionStatusEnum = {

    PENDING: 'PENDING' as IncortaSubscriptionStatusEnum,

    DONE: 'DONE' as IncortaSubscriptionStatusEnum,

    FAILED: 'FAILED' as IncortaSubscriptionStatusEnum
};

